import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/** Icon-only toggle for headers (landing nav, sign-in pages). */
export function ThemeToggleButton({ className = '' }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-md border border-line-strong bg-transparent text-ink transition-colors hover:bg-sunken ${className}`}
    >
      {isDark ? <Sun className="h-5 w-5" strokeWidth={1.5} /> : <Moon className="h-5 w-5" strokeWidth={1.5} />}
    </button>
  );
}

/** Labelled switch for the app sidebar. */
export function ThemeSwitch({ className = '' }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      onClick={toggleTheme}
      data-testid="theme-switch"
      className={`flex h-11 w-full items-center gap-3 rounded-md border border-line px-3 text-[15px] font-bold text-ink transition-colors hover:bg-sunken ${className}`}
    >
      <Moon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" />
      Dark mode
      <span
        aria-hidden="true"
        className={`relative ml-auto inline-block h-5 w-9 rounded-sm border transition-colors ${
          isDark ? 'border-marker bg-marker' : 'border-line-strong bg-sunken'
        }`}
      >
        <span
          className={`absolute top-[2px] h-3.5 w-3.5 rounded-[1px] transition-[left] duration-150 motion-reduce:transition-none ${
            isDark ? 'left-[18px] bg-[#14171c]' : 'left-[2px] bg-line-strong'
          }`}
        />
      </span>
    </button>
  );
}
